import { createClient } from "microcms-js-sdk";

export const client = createClient({
  serviceDomain: process.env.REACT_APP_MICROCMS_DOMAIN ?? "",
  apiKey: process.env.REACT_APP_MICROCMS_API_KEY ?? "",
});